/* eslint-disable */
import * as d3 from 'd3';
import {debuggableClass, memo} from 'utils/decorators';

@debuggableClass
export default class ElementAnimation {
  constructor(
    public elem: SVGElement,
    public startDelay: number,
    public duration: number,
    public type: 'LEFT_RIGHT' | 'UPSCALE' | 'IN_OUT' | 'DRAW_PATH' | 'FADE_IN',
  ) {}
  @memo get viewBoxCenter() {
    return [0, 0];
  }
  @memo get sel() {
    return d3.select(this.elem);
  }
  @memo get parentSel() {
    return this.sel.select(function(this: any) {
      return this.parentNode;
    });
  }
  @memo get bboxTargetElem() {
    return this.elem;
  }
  @memo get bboxRaw() {
    return (this.bboxTargetElem as SVGGraphicsElement).getBBox();
  }
  @memo get bbox() {
    const {x: x0, y: y0, width: w, height: h} = this.bboxRaw;
    const c = 1; // SvgObject.boundingClientRectCoeff;
    return new DOMRect(x0 * c, y0 * c, w * c, h * c);
  }
  @memo get cx() {
    return this.bbox.x + this.bbox.width / 2;
  }
  @memo get cy() {
    return this.bbox.y + this.bbox.height / 2;
  }
  @memo get directionToViewBoxCenter() {
    const dx = this.cx - this.viewBoxCenter[0];
    const dy = this.cy - this.viewBoxCenter[1];
    const n = (dx ** 2 + dy ** 2) ** 0.5;
    return [dx / n, dy / n];
  }
  @memo get inOutTranslationLen() {
    return 100;
  }
  @memo get inOutTranslationStr() {
    const [dx, dy] = this.directionToViewBoxCenter;
    const c = -this.inOutTranslationLen;
    return `translate(${dx * c} ${dy * c})`;
  }
  @memo get pathLength() {
    return (this.elem as SVGPathElement).getTotalLength();
  }
  transformAroundCenter(transform: string) {
    return `translate(${this.cx}, ${this.cy}) ${transform} translate(${-this.cx}, ${-this.cy})`;
  }
  showBbox() {
    this.parentSel
      .append('rect')
      .attr('x', this.bbox.x)
      .attr('y', this.bbox.y)
      .attr('width', this.bbox.width)
      .attr('height', this.bbox.height)
      .attr('stroke', 'red')
      .attr('fill', 'none');
    return this;
  }
  setState(sel: d3.Selection<any, any, any, any>, isInit: boolean) {
    sel
      .attr(
        'transform',
        this.transformAroundCenter(
          {
            LEFT_RIGHT: isInit ? 'translate(-10 0)' : 'translate(0 0)',
            UPSCALE: isInit ? 'scale(0)' : 'scale(1)',
            IN_OUT: isInit ? this.inOutTranslationStr : 'translate(0 0)',
            DRAW_PATH: '',
            FADE_IN: '',
          }[this.type],
        ),
      )
      .attr('opacity', isInit ? '0' : '1');
    if (this.type === 'DRAW_PATH') {
      sel
        .attr('stroke-dasharray', this.pathLength)
        .attr('stroke-dashoffset', isInit ? this.pathLength : 0);
    }
    return this;
  }
  setInitialState() {
    // this.showBbox();
    return this.setState(this.sel, true);
  }
  startAnimation() {
    return this.setState((this.sel.transition() as any).duration(this.duration), false);
  }
  start() {
    setTimeout(() => {
      this.startAnimation();
    }, this.startDelay);
    return this;
  }
}
